<template>
  <div class="tab-content pt-dashboard-light" id="PTtab-5" :key="'PTtab-5'" v-if="isLoaded">
    <div class="main-contents-wrapper">
      <div class="dashboard-hero">
        <h1>DASHBOARD</h1>
        <p class="dashtext">
          {{ $t('front.common.moneyDW') }} / {{ $t('front.common.history') }} / {{ $t('front.common.notice') }}<br />
          {{ $t('front.common.balance') }} = {{ $t('front.cash.nav3') }} + {{ $t('front.cash.rolling') }}, {{ $t('front.common.totalAmount') }}
        </p>
      </div>

      <div class="pt-dashwrap">
        <ul class="pt-dashth">
          <li class="pt-dash-card inout">
            <ul class="pt-dashlist">
              <li>
                {{ $t('front.cash.charge') }}
                <span>{{ thousand(mainStatisticsInfo.dCashIn || 0) }}</span>
              </li>
              <li>
                <span>{{ $t('front.message.num') }}</span>
                <span>{{ thousand(mainStatisticsInfo.dCashInCnt || 0) }} {{ $t('front.message.num') }}</span>
              </li>
              <li>
                <span>{{ $t('front.cash.totalCharge') }}</span>
                <span>{{ thousand(cashReport.inPaymentSum || 0) }}</span>
              </li>
            </ul>
          </li>

          <li class="pt-dash-card inout">
            <ul class="pt-dashlist">
              <li>
                {{ $t('front.cash.exchange') }}
                <span>{{ thousand(mainStatisticsInfo.dCashOut || 0) }}</span>
              </li>
              <li>
                <span>{{ $t('front.message.num') }}</span>
                <span>{{ thousand(mainStatisticsInfo.dCashOutCnt || 0) }} {{ $t('front.message.num') }}</span>
              </li>
              <li>
                <span>{{ $t('front.cash.totalExchange') }}</span>
                <span>{{ thousand(cashReport.outPaybackSum || 0) }}</span>
              </li>
            </ul>
          </li>

          <li class="pt-dash-card inout">
            <ul class="pt-dashlist">
              <li>
                {{ $t('front.cash.chargeR') }}
                <span>{{ thousand(mainStatisticsInfo.dPayment || 0) }}</span>
              </li>
              <li>
                <span>{{ $t('front.common.managerPay') }}</span>
                <span>{{ thousand(myCashReport.adminPayment || 0) }}</span>
              </li>
              <li>
                <span>{{ $t('front.common.topPay') }}</span>
                <span>{{ thousand(myCashReport.upperPayment || 0) }}</span>
              </li>
            </ul>
          </li>

          <li class="pt-dash-card new">
            <ul class="pt-dashlist">
              <li>
                {{ $t('front.cash.retriR') }}
                <span>{{ thousand(mainStatisticsInfo.dPayback || 0) }}</span>
              </li>
              <li>
                <span>{{ $t('front.common.managerRetri') }}</span>
                <span>{{ thousand(myCashReport.adminPayback || 0) }}</span>
              </li>
              <li>
                <span>{{ $t('front.common.topRetri') }}</span>
                <span>{{ thousand(myCashReport.upperPayback || 0) }}</span>
              </li>
            </ul>
          </li>
        </ul>

        <ul class="pt-dashth">
          <li class="pt-dash-card bet">
            <ul class="pt-dashlist">
              <li>
                {{ $t('front.cash.memberBalance') }}
                <span>{{ thousand(cashReport.normalCashAmt || 0) }}</span>
              </li>
              <li>
                <span>{{ $t('front.cash.partnerBalance') }}</span>
                <span>{{ thousand(cashReport.partnerCashAmt || 0) }}</span>
              </li>
              <li>
                <span>{{ $t('front.common.bUserPt') }}</span>
                <span>{{ thousand(cashReport.totalPointAmt || 0) }}</span>
              </li>
            </ul>
          </li>

          <li class="pt-dash-card bet">
            <ul class="pt-dashlist">
              <li>
                {{ $t('front.stributor.m22') }}
                <span>{{ thousand(cashReport.betAmt || 0) }}</span>
              </li>
              <li>
                <span>{{ $t('front.stributor.m23') }}</span>
                <span>{{ thousand(cashReport.winAmt || 0) }}</span>
              </li>
              <li>
                <span>{{ $t('front.bettingStatus.BET') }} - {{ $t('front.common.winning') }}</span>
                <span>{{ thousand(cashReport.betBEP || 0) }}</span>
              </li>
            </ul>
          </li>

          <li class="pt-dash-card bet">
            <ul class="pt-dashlist">
              <li>
                {{ $t('front.cash.coupon') }}
                <span>{{ thousand(cashReport.couponCash || 0) }}</span>
              </li>
              <li>
                <span>{{ $t('front.common.toRolling') }}</span>
                <span>{{ thousand(myCashReport.changePoint || 0) }}</span>
              </li>
              <li>
                <span>{{ $t('front.common.bottomR') }}</span>
                <span>{{ thousand(myCashReport.myPayback || 0) }}</span>
              </li>
            </ul>
          </li>

          <li class="pt-dash-card new">
            <ul class="pt-dashlist">
              <li>
                {{ $t('front.common.newMember') }}
                <span>{{ thousand(mainStatisticsInfo.dJoinCnt || 0) }} {{ $t('front.message.num') }}</span>
              </li>
              <li>
                <span>{{ $t('front.common.betProfit') }}</span>
                <span>{{ thousand(mainStatisticsInfo.dBetBEP || 0) }}</span>
              </li>
              <li>
                <span>{{ $t('front.common.totalAmount') }}</span>
                <span>{{ thousand(myCashReport.increaseTotal || 0) }}</span>
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <section class="pt-panel money-panel">
        <div class="pt-panel-head">
          <h3>[{{ $t('front.common.moneyDW') }}] {{ $t('front.common.balance') }}</h3>
          <date-filter-Pt :startDate="cashReportTable.startDate"
                          :endDate="cashReportTable.endDate"
                          @update="updateDateCashReport"
                          @search="loadCashReport" />
        </div>
        <div class="pt-table-scroll">
          <table class="pt-table">
            <colgroup>
              <col width="7.7%"/>
              <col width="7.7%"/>
              <col width="7.7%"/>
              <col width="7.7%"/>
              <col width="7.7%"/>
              <col width="7.7%"/>
              <col width="7.7%"/>
              <col width="7.7%"/>
              <col width="7.7%"/>
              <col width="7.7%"/>
              <col width="7.7%"/>
              <col width="7.7%"/>
              <col width="7.7%"/>
            </colgroup>
            <thead>
              <tr>
                <th colspan="3" class="bgb">{{ $t('front.cash.charge') }}</th>
                <th colspan="3" class="bgc">{{ $t('front.cash.exchange') }}</th>
                <th rowspan="2" class="bgb">{{ $t('front.cash.coupon') }}</th>
                <th colspan="2" class="bgd">{{ $t('front.cash.currentBalance') }}</th>
                <th colspan="3" class="bgb">{{ $t('front.bettingStatus.BET') }} / {{ $t('front.common.winning') }}</th>
                <th rowspan="2" class="bga">{{ $t('front.common.bUserPt') }}</th>
              </tr>
              <tr>
                <th class="bgb">{{ $t('front.cash.charge') }}</th>
                <th class="bgb">{{ $t('front.cash.chargeR') }}</th>
                <th class="bgb">{{ $t('front.cash.totalCharge') }}</th>
                <th class="bgc">{{ $t('front.cash.exchange') }}</th>
                <th class="bgc">{{ $t('front.cash.retriR') }}</th>
                <th class="bgc">{{ $t('front.cash.totalExchange') }}</th>
                <th class="bgd">{{ $t('front.cash.memberBalance') }}</th>
                <th class="bgd">{{ $t('front.cash.partnerBalance') }}</th>
                <th class="bgb">{{ $t('front.stributor.m22') }}</th>
                <th class="bgb">{{ $t('front.stributor.m23') }}</th>
                <th class="bgb">{{ $t('front.bettingStatus.BET') }} - {{ $t('front.common.winning') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ thousand(cashReport.cashIn || 0) }}</td>
                <td>{{ thousand(cashReport.payment || 0) }}</td>
                <td>{{ thousand(cashReport.inPaymentSum || 0) }}</td>
                <td>{{ thousand(cashReport.cashOut || 0) }}</td>
                <td>{{ thousand(cashReport.payback || 0) }}</td>
                <td>{{ thousand(cashReport.outPaybackSum || 0) }}</td>
                <td>{{ thousand(cashReport.couponCash || 0) }}</td>
                <td>{{ thousand(cashReport.normalCashAmt || 0) }}</td>
                <td>{{ thousand(cashReport.partnerCashAmt || 0) }}</td>
                <td>{{ thousand(cashReport.betAmt || 0) }}</td>
                <td>{{ thousand(cashReport.winAmt || 0) }}</td>
                <td>{{ thousand(cashReport.betBEP || 0) }}</td>
                <td>{{ thousand(cashReport.totalPointAmt || 0) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section class="pt-panel money-panel">
        <div class="pt-panel-head">
          <h3>{{ $t('front.common.history') }}</h3>
          <date-filter-Pt :startDate="myCashReportTable.startDate"
                          :endDate="myCashReportTable.endDate"
                          @update="updateDateMyCashReport"
                          @search="loadMyCashReport" />
        </div>
        <div class="pt-table-scroll">
          <table class="pt-table">
            <colgroup>
              <col width="8%"/>
              <col width="8%"/>
              <col width="8%"/>
              <col width="8%"/>
              <col width="8%"/>
              <col width="8%"/>
              <col width="8%"/>
              <col width="8%"/>
              <col width="8%"/>
              <col width="8%"/>
              <col width="8%"/>
              <col width="8%"/>
            </colgroup>
            <thead>
              <tr>
                <th colspan="7" class="bgb">{{ $t('front.common.increaseRe') }}</th>
                <th colspan="5" class="bgc">{{ $t('front.common.decreaseRe') }}</th>
              </tr>
              <tr>
                <th class="bgb">{{ $t('front.common.deposit') }}</th>
                <th class="bgb">{{ $t('front.common.managerPay') }}</th>
                <th class="bgb">{{ $t('front.common.topPay') }}</th>
                <th class="bgb">{{ $t('front.common.bottomR') }}</th>
                <th class="bgb">{{ $t('front.common.toRolling') }}</th>
                <th class="bgb">{{ $t('front.cash.coupon') }}</th>
                <th class="bgb">{{ $t('front.common.totalIncrease') }}</th>
                <th class="bgc">{{ $t('front.common.withdrawal') }}</th>
                <th class="bgc">{{ $t('front.common.managerRetri') }}</th>
                <th class="bgc">{{ $t('front.common.topRetri') }}</th>
                <th class="bgc">{{ $t('front.common.bottomPay') }}</th>
                <th class="bgc">{{ $t('front.common.totalDecrease') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ thousand(myCashReport.cashIn || 0) }}</td>
                <td>{{ thousand(myCashReport.adminPayment || 0) }}</td>
                <td>{{ thousand(myCashReport.upperPayment || 0) }}</td>
                <td>{{ thousand(myCashReport.myPayback || 0) }}</td>
                <td>{{ thousand(myCashReport.changePoint || 0) }}</td>
                <td>{{ thousand(myCashReport.couponCash || 0) }}</td>
                <td>{{ thousand(myCashReport.increaseTotal || 0) }}</td>
                <td>{{ thousand(myCashReport.cashOut || 0) }}</td>
                <td>{{ thousand(myCashReport.adminPayback || 0) }}</td>
                <td>{{ thousand(myCashReport.upperPayback || 0) }}</td>
                <td>{{ thousand(myCashReport.myPayment || 0) }}</td>
                <td>{{ thousand(myCashReport.decreaseTotal || 0) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section class="pt-panel notice-panel">
        <div class="pt-panel-head only-title">
          <h3>{{ $t('front.common.notice') }}</h3>
        </div>
        <gibang-pinned-notice link-only />
        <div class="pt-list-table">
          <ul class="pt-list-head">
            <li style="width: 10%;">#</li>
            <li style="width: 65%;">{{ $t('front.board.title') }}</li>
            <li style="width: 25%;">{{ $t('front.common.time') }}</li>
          </ul>
          <template v-if="boardList && boardList.length > 0">
            <template v-for="item in boardList" :key="item.boardIdx">
              <ul class="pt-list-row">
                <li style="width: 10%;">{{ item.boardIdx }}</li>
                <li style="width: 65%;"><a @click.prevent="onClickRead(item.boardIdx)">{{ item.title }}</a></li>
                <li style="width: 25%;">{{ item.regDate }}</li>
              </ul>
            </template>
          </template>
          <template v-else>
            <ul class="pt-list-row empty">
              <li style="width: 100%;">{{ $t('front.common.notFoundList') }}</li>
            </ul>
          </template>
        </div>
      </section>

      <div class="pt-two-column">
        <section class="pt-panel list-panel">
          <div class="pt-panel-head only-title">
            <h3>{{ $t('front.common.recentPay') }}</h3>
          </div>
          <div class="pt-list-table">
            <ul class="pt-list-head">
              <li style="width: 5%;">#</li>
              <li style="width: 35%;">{{ $t('front.common.nickName') }}</li>
              <li style="width: 25%;">{{ $t('front.give.moneys') }}</li>
              <li style="width: 35%;">{{ $t('front.common.time') }}</li>
            </ul>
            <template v-if="newPaymentList && newPaymentList.length">
              <template v-for="(item, idx) in newPaymentList" :key="item.updDate">
                <ul class="pt-list-row">
                  <li style="width: 5%;">{{ idx + 1 }}</li>
                  <li style="width: 35%;">{{ item.memNick }}</li>
                  <li style="width: 25%;">{{ thousand(item.cashAmt || 0) }}</li>
                  <li style="width: 35%;">{{ item.updDate.replace('T', ' ') }}</li>
                </ul>
              </template>
            </template>
            <template v-else>
              <ul class="pt-list-row empty">
                <li style="width: 100%;">{{ $t('front.common.noPayment') }}</li>
              </ul>
            </template>
          </div>
        </section>

        <section class="pt-panel list-panel">
          <div class="pt-panel-head only-title">
            <h3>{{ $t('front.common.recentRetri') }}</h3>
          </div>
          <div class="pt-list-table">
            <ul class="pt-list-head">
              <li style="width: 5%;">#</li>
              <li style="width: 35%;">{{ $t('front.common.nickName') }}</li>
              <li style="width: 25%;">{{ $t('front.give.moneys') }}</li>
              <li style="width: 35%;">{{ $t('front.common.time') }}</li>
            </ul>
            <template v-if="newPaybackList && newPaybackList.length">
              <template v-for="(item, idx) in newPaybackList" :key="item.updDate">
                <ul class="pt-list-row">
                  <li style="width: 5%;">{{ idx + 1 }}</li>
                  <li style="width: 35%;">{{ item.memNick }}</li>
                  <li style="width: 25%;">{{ thousand(item.cashAmt || 0) }}</li>
                  <li style="width: 35%;">{{ item.updDate.replace('T', ' ') }}</li>
                </ul>
              </template>
            </template>
            <template v-else>
              <ul class="pt-list-row empty">
                <li style="width: 100%;">{{ $t('front.common.noRetrieve') }}</li>
              </ul>
            </template>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import DateFilterPt from '@/components/ui/DateFilterPt'
import { getMainCashReport, getMainMyCashReport, getMainNewPay, getMainStatistics } from '@/api/v2/main'
import { getDateStr, thousand } from '@/libs/utils'
import { addDays } from 'date-fns'
import { getMainNotice } from '@/api/main'
import GibangPinnedNotice from '@/components/common/GibangPinnedNotice.vue'
export default {
  name: 'partnerMain',
  components: { DateFilterPt, GibangPinnedNotice },
  computed: {
    isLoaded () {
      return this.mainStatisticsInfo && this.cashReport && this.myCashReport
    }
  },
  data () {
    return {
      cashReportTable: {
        startDate: getDateStr(addDays(new Date(), 0), 'yyyy-MM-dd 00:00:00'),
        endDate: getDateStr(addDays(new Date(), 0), 'yyyy-MM-dd 23:59:59')
      },
      myCashReportTable: {
        startDate: getDateStr(addDays(new Date(), 0), 'yyyy-MM-dd 00:00:00'),
        endDate: getDateStr(addDays(new Date(), 0), 'yyyy-MM-dd 23:59:59')
      },
      mainStatisticsInfo: null,
      cashReport: null,
      myCashReport: null,
      boardList: [],
      newPaymentList: [],
      newPaybackList: []
    }
  },
  async created () {
    this.emitter.emit('Loading', true)
    this.loadStatistics()
    this.loadCashReport()
    this.loadMyCashReport()
    this.loadMainNotice()
    this.loadNewPayLog()
    this.emitter.emit('Loading', false)
  },
  watch: {
  },
  methods: {
    thousand,
    onClickRead (id) {
      if (!id) id = 1
      this.$router.push({ name: 'noticeRead', params: { boardIdx: id } })
    },
    loadStatistics () {
      getMainStatistics({}).then(res => {
        const result = res.data
        if (result.resultCode === '0') {
          this.mainStatisticsInfo = { ...result.data.mainStatisticsInfo }
        }
      })
    },
    loadCashReport () {
      const param = {
        startDate: this.cashReportTable.startDate.split(' ')[0],
        endDate: this.cashReportTable.endDate.split(' ')[0]
      }
      getMainCashReport(param).then(res => {
        const result = res.data
        if (result.resultCode === '0') {
          this.cashReport = { ...result.data.cashReport }
        } else {
          this.onAlert('warning', result.resultMessage)
        }
      })
    },
    loadMyCashReport () {
      const param = {
        startDate: this.myCashReportTable.startDate.split(' ')[0],
        endDate: this.myCashReportTable.endDate.split(' ')[0]
      }
      getMainMyCashReport(param).then(res => {
        const result = res.data
        if (result.resultCode === '0') {
          this.myCashReport = { ...result.data.myCashReport }
        } else {
          this.onAlert('warning', result.resultMessage)
        }
      })
    },
    updateDateCashReport (value) {
      this.cashReportTable = { ...value }
    },
    updateDateMyCashReport (value) {
      this.myCashReportTable = { ...value }
    },
    loadMainNotice () {
      getMainNotice({}).then(res => {
        const result = res.data
        if (result.resultCode === '0') {
          this.boardList = result.data.boardList
        } else {
          this.onAlert('warning', result.resultMessage)
        }
      })
    },
    loadNewPayLog () {
      getMainNewPay({}).then(res => {
        const result = res.data
        if (result.resultCode === '0') {
          this.newPaymentList = result.data.mainNewPayLog.newPaymentList
          this.newPaybackList = result.data.mainNewPayLog.newPaybackList
        } else {
          this.onAlert('warning', result.resultMessage)
        }
      })
    }
  }
}
</script>

<style src="@/styles/striNew.css"></style>
<style scoped>
.pt-dashboard-light {
  width: 100%;
  min-height: calc(100vh - 63px);
  padding: 24px 18px 60px;
  box-sizing: border-box;
  background: #f5f7fb;
  color: #1f2937;
}

.main-contents-wrapper {
  width: 100%;
  box-sizing: border-box;
}

.dashboard-hero h1 {
  margin: 0;
  padding: 10px 0 8px;
  font-size: 30px;
  line-height: 1.1;
  font-weight: 900;
  color: #111827;
  letter-spacing: -0.5px;
}

.dashtext {
  margin: 0;
  color: #64748b;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.55;
}

.pt-dashwrap {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 28px;
}

.pt-dashth {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.pt-dash-card {
  min-height: 118px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-top: 6px solid #ff9843;
  border-radius: 6px;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.06);
  overflow: hidden;
}

.pt-dash-card.bet {
  border-top-color: #10b981;
}

.pt-dash-card.new {
  border-top-color: #8b5cf6;
}

.pt-dashlist {
  margin: 0;
  padding: 0;
  list-style: none;
}

.pt-dashlist li {
  min-height: 33px;
  padding: 0 16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  color: #64748b;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.25;
}

.pt-dashlist li:first-child {
  min-height: 46px;
  border-bottom: 1px solid #e5e7eb;
  background: #f8fafc;
  color: #334155;
  font-size: 17px;
  font-weight: 900;
}

.pt-dashlist li:first-child span {
  color: #111827;
  font-size: 19px;
  font-weight: 900;
}

.pt-dashlist li span:last-child {
  margin-left: auto;
  color: #334155;
  font-weight: 900;
  white-space: nowrap;
}

.pt-panel {
  margin-top: 26px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-top: 7px solid #2f78ee;
  border-radius: 6px 6px 0 0;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.06);
  overflow: hidden;
  box-sizing: border-box;
}

.pt-panel.notice-panel {
  border-top-color: #8b5cf6;
}

.pt-panel.list-panel {
  margin-top: 0;
  border-top-color: #06b6d4;
}

.pt-panel-head {
  min-height: 51px;
  padding: 10px 16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  background: #f8fafc;
  border-bottom: 1px solid #e5e7eb;
}

.pt-panel-head.only-title {
  justify-content: flex-start;
}

.pt-panel-head h3 {
  margin: 0;
  color: #334155;
  font-size: 17px;
  font-weight: 900;
  line-height: 1.35;
}

.pt-table-scroll {
  width: 100%;
  overflow-x: auto;
}

.pt-table {
  width: 100%;
  min-width: 1180px;
  text-align: center;
  vertical-align: middle;
  font-size: 13px;
  border-collapse: collapse;
  border-spacing: 0;
}

.pt-table th {
  height: 37px;
  padding: 0 8px;
  color: #1f2937;
  vertical-align: middle;
  border: 1px solid #d9e0ea;
  line-height: 1.35;
  font-weight: 900;
  white-space: nowrap;
}

.pt-table td {
  box-sizing: border-box;
  height: 37px;
  padding: 8px 8px;
  color: #111827;
  vertical-align: middle;
  border: 1px solid #e5e7eb;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 13px;
  line-height: 1.2;
  background: #fff;
}

.pt-table tbody tr:hover td,
.pt-list-row:hover {
  background: #f8fafc;
}

th.bga { background-color: #e8edf3; }
th.bgb { background-color: #e6f6ff; }
th.bgc { background-color: #fff0ed; }
th.bgd { background-color: #f2ecff; }

.pt-list-table {
  width: 100%;
}

.pt-list-head,
.pt-list-row {
  min-height: 38px;
  display: flex;
  flex-wrap: nowrap;
  margin: 0;
  padding: 0;
  list-style: none;
  color: #1f2937;
  font-size: 13px;
  border-bottom: 1px solid #e5e7eb;
  box-sizing: border-box;
}

.pt-list-head {
  min-height: 40px;
  background: #e6f6ff;
  font-weight: 900;
}

.notice-panel .pt-list-head {
  background: #f2ecff;
}

.pt-list-head li,
.pt-list-row li {
  min-width: 0;
  padding: 0 10px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pt-list-row {
  background: #fff;
}

.pt-list-row.empty li {
  justify-content: center;
  color: #64748b;
}

.pt-list-row a {
  color: #1f2937;
  cursor: pointer;
  text-decoration: none;
}

.pt-list-row a:hover {
  color: #2f78ee;
  text-decoration: underline;
}

.pt-two-column {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
  margin-top: 26px;
}

@media (max-width: 1280px) {
  .pt-dashth {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 1000px) {
  .pt-dashboard-light {
    padding: 16px 10px 40px;
  }

  .pt-dashth,
  .pt-two-column {
    grid-template-columns: 1fr;
  }

  .pt-panel-head {
    align-items: flex-start;
    flex-direction: column;
  }

  .dashboard-hero h1 {
    font-size: 26px;
  }
}
</style>
